// extracted by mini-css-extract-plugin
export default {"card":"Card_card__qeZfG","card_header":"Card_card_header__a7ZsT","title":"Card_title__r3wOG"};